<template>
  <div>
    <vant-image width="100%"
                height="100%"
                src="https://gd-pub.jinshujufiles.com/hi/20200320125134_072018" />
  </div>
</template>

<script>
import { Image as VanImage } from 'vant'

export default {
  name: 'mobile-requirement-form',
  components: {
    'vant-image': VanImage,
  },
  data() {
    return {}
  },
}
</script>

<style>
</style>